<template>
  <div class="mt-4">
    <b-row>
      <b-col md="12" class="col-12 mb-3">
        <div>
          <b-form-checkbox
            v-model="selecionarTodos"
            @change="marcarDesmarcarTodos"
          >
            {{ $t('GERAL.SELECIONAR_TODOS') }}
          </b-form-checkbox>

          <strong v-if="selecionarTodos">
            {{ $t('GERAL.SELECIONAR_TODOS_AVISO') }}
          </strong>
        </div>
      </b-col>
    </b-row>
    <b-table
      class="tabela-contas-receber"
      :items="table.items"
      :fields="table.fields"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      :tbody-tr-class="retornarClasseLinhaAno"
      show-empty
      responsive
      no-local-sorting
      @sort-changed="aoMudarOrdenacao"
      striped
      hover
    >
      <template #cell(liberadoPortal)="item">
        <div>
          <b-badge
            v-if="item.item.liberadoPortal != null"
            :variant="item.item.liberadoPortal == true ? 'info' : 'warning'"
          >
            {{
              item.item.liberadoPortal == true
                ? $t('FINANCEIRO_CONTAS_RECEBER.LIBERADO_PORTAL_ALUNO')
                : $t('FINANCEIRO_CONTAS_RECEBER.NAO_LIBERADO_PORTAL_ALUNO')
            }}
          </b-badge>
        </div>
      </template>
      <template #cell(marcar)="item">
        <b-form-checkbox
          v-if="!item.item.numeroMatricula"
          v-model="item.item.checked"
          :value="true"
          :unchecked-value="false"
          @change="marcaDesmarcaUm(item.item)"
        />
      </template>
      <template #cell(valor)="item">
        {{ formatarValor(item.item.valor) }}
      </template>
      <template #cell(historicoDescricao)="item">
        {{
          !item.item.codigo
            ? `${item.item.numeroMatricula} - ${item.item.nomeAluno}`
            : `${item.item.codigo} - ${item.item.historicoDescricao}`
        }}
      </template>
      <template #cell(statusPagamentoDescricao)="item">
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Cancelado'"
          style="background: red"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Liquidado'"
          style="background: green"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Liquidado Parcialmente'"
          style="background: #7ccd7c"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Estornado'"
          style="background: #3a443a"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          class="estilo-status-tabela"
          v-if="item.item.statusPagamentoDescricao == 'Aberto'"
          style="background: #fbcd00"
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
        <div
          v-if="
            item.item.statusPagamentoDescricao !== 'Aberto' &&
            item.item.statusPagamentoDescricao !== 'Liquidado' &&
            item.item.statusPagamentoDescricao !== 'Liquidado Parcialmente' &&
            item.item.statusPagamentoDescricao !== 'Estornado' &&
            item.item.statusPagamentoDescricao !== 'Cancelado'
          "
        >
          {{ item.item.statusPagamentoDescricao }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  props: {
    items: { type: Array, default: () => [] },
    filtrarPor: { type: [Object, Array], default: () => {} },
  },
  data() {
    return {
      table: {
        items: [],
        fields: [
          { key: 'marcar', label: '' },
          { key: 'historicoDescricao', label: 'Documento - Histórico' },
          {
            key: 'valor',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.VALOR'),
            formatter: (value) => {
              return value ? helpers.formatacaoMoedaBRL(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'juros',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.JUROS'),
            formatter: (value) => {
              return value ? helpers.formatacaoMoedaBRL(value) : '-';
            },
          },
          {
            key: 'desconto',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.DESCONTO'),
            formatter: (value) => {
              return value ? helpers.formatacaoMoedaBRL(value) : '-';
            },
          },
          {
            key: 'total',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.TOTAL'),
            formatter: (value) => {
              return value ? helpers.formatacaoMoedaBRL(value) : '-';
            },
          },
          {
            key: 'dataVencimento',
            label: 'Dt. Venc.',
            formatter: (value) => {
              return value ? helpers.formatarDataBr(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'dataPagamento',
            label: 'Dt. Pag.',
            formatter: (value) => {
              return value ? helpers.formatarDataBr(value) : '-';
            },
            sortable: true,
          },
          {
            key: 'recibo',
            label: this.$t('FINANCEIRO.RECIBO'),
            formatter: (value) => {
              return value === 0 ? '' : value;
            },
          },
          {
            key: 'statusPagamentoDescricao',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.STATUS_PAGAMENTO'),
          },
          {
            key: 'liberadoPortal',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.ACESSO_PORTAL'),
          },
          {
            key: 'contaDescricaoComCodigo',
            label: this.$t('FINANCEIRO_CONTAS_RECEBER.CONTA'),
          },
          {
            key: 'dataLancamento',
            label: 'Dt. Lanç.',
            formatter: (value) => {
              return value ? helpers.formatarDataBr(value) : '-';
            },
            sortable: true,
          },
        ],
      },
      selecionarTodos: false,
    };
  },
  methods: {
    formatarValor(valor) {
      return valor ? helpers.formatacaoMoedaBRL(valor) : '';
    },
    desmarcarTodos() {
      this.table.items.forEach((item) => {
        item.checked = false;
      });
      this.emitirDados();
    },
    marcarDesmarcarTodos() {
      this.table.items.forEach((item) => {
        item.checked = this.selecionarTodos;
      });
      this.emitirDados();
    },
    marcaDesmarcaUm(item) {
      if (!item.checked) {
        this.selecionarTodos = false;
      } else {
        this.selecionarTodos = this.table.items.every((item) => item.checked);
      }
      this.emitirDados();
    },
    emitirDados() {
      let itensSelecionados = this.table.items.filter(
        (item) => item.checked && item.nomeAluno == null
      );

      var arr = itensSelecionados.map((item) => {
        return item.codigoMatricula;
      });
      const allEqual = arr.every((v) => v === arr[0]);
      this.$emit('itens-selecionados-tabela', itensSelecionados, allEqual);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      this.$emit('alterar-ordenacao', sortBy, sortDesc);
    },
    retornarClasseLinhaAno(item, type) {
      if (!item || type !== 'row') return;
      const classes = [];
      if (item.nomeAluno) classes.push('line-table-custom');
      if (item.statusPagamentoDescricao === 'Liquidado Parcialmente') {
        classes.push('linha-liquidado-parcialmente');
      }
      return classes.join(' ');
    },
  },
  watch: {
    items: {
      handler(newItems) {
        this.table.items = newItems.map((item) => ({
          ...item,
          checked: false,
        }));
      },
      immediate: true,
    },
  },
};
</script>

<style>
.tabela-contas-receber {
  white-space: nowrap;
  font-size: 14px;
}
.tabela-contas-receber .thead-light th {
  padding: 15px 0.4rem !important;
}
.tabela-contas-receber td {
  padding: 5px 0.4rem !important;
}
.tabela-contas-receber tbody tr.linha-liquidado-parcialmente > td {
  background-color: #eaf7ea !important;
  border-top: 1px solid #a8dba8 !important;
}
</style>
